<mat-dialog-content class="overflow-hidden" style="max-height:inherit">
    <div class="d-flex justify-content-between">
        <h5 class="fw-semibold">Wetterdaten vom Gerät:&nbsp;{{ deviceName }}</h5>
        <img class="ms-3 avs-modal-close-btn mb-1" width="30" src="assets/icons/x.svg" alt="close-modal-icon"
            (click)="onCloseDialogClicked()">
    </div>
    <div class="d-flex justify-content-center align-items-center mb-2">
        Von vor&nbsp;
        <input class="ms-1 me-1 form-control rounded-0 form-control-sm" style="width: 70px" type="number"
            [(ngModel)]="fromDate" (ngModelChange)="setFromDate(fromDate)" min="1" max="14">
            &nbsp;Tagen&nbsp;bis zu
        <input class="ms-1 me-1 form-control rounded-0 form-control-sm" style="width: 70px" type="number"
            [(ngModel)]="toDate" (ngModelChange)="setToDate(toDate)" min="0" max="13">
            &nbsp;Tagen
        <button (click)="removeData()" class="btn rounded-0 btn-outline-success ms-5   ms-sm-5 btn-sm"> Update
        </button>
    </div>
    <div class="d-flex flex-1 mh-100 h-100 flex-column justify-content-center align-content-center">
        <div class="p-5 overflow-scroll">
            <div *ngFor="let chartView of chartViews" class="d-flex flex-column">
                <p class="fw-semibold text-secondary">{{ chartView.title }}</p>
                <div class="chart-container d-flex justify-content-center overflow-scroll">
                    <div class="chart-container w-100">
                        <canvas #weatherCanvas></canvas>
                    </div>
                </div>
            </div>
            <p *ngIf="!hasData" class="p-2 fw-semibold text-secondary">
                Für den ausgewählten Zeitraum liegen keine Wetterdaten vor
            </p>
        </div>
    </div>
</mat-dialog-content>

<div mat-dialog-actions class="d-flex justify-content-between m-4">
    <button (click)="exportChart()" class="btn rounded-0 btn-outline-success btn-sm"> Export
    </button>
    <button (click)="onCloseDialogClicked()" class="btn rounded-0 btn-outline-danger btn-sm">
        Schließen
    </button>
</div>
